export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART = 'UPDATE_CART';

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';

export const CHANGE_SETTING = 'CHANGE_SETTING'; 

export const SELECTED_PRODUCT = 'SELECTED_PRODUCT';

export const SAVE_ORDER = 'SAVE_ORDER'; 

export const SELECTED_ORDER = 'SELECTED_ORDER';


// WEBPACK FOOTER //
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/src/app/redux/actions/action.ts